import { Button } from 'antd';
import styles from './index.module.less';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';

const TrackDisabledItem = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.content}>
      <div>
        <div className={styles.title}>{t('TrackingIsDisabledNow')}</div>
        <div className={styles.desc}>{t('PleaseChooseThePlan_Desc')}</div>
      </div>

      <Link href={'/plan'}>
        <Button className={styles.btn}>{t('BUY_SUBSCRIPTION')}</Button>
      </Link>
    </div>
  );
};

export default TrackDisabledItem;
